<template>
  <div>
    <incident-badge
      v-if="valueIsDefined"
      :incidents="params.value"
    />
  </div>
</template>

<script>

import Vue from 'vue'
import IncidentBadge from '@/components/common/IncidentBadge'

export default Vue.extend({
    name: 'IncidentRenderer',
    components: {
        IncidentBadge
    },
    computed: {
        valueIsDefined() {
            return this.params.value > 0
        }
    }
})

</script>
